import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import loader from "../../Images/ajax-loader.gif";
import {
  getDrinkingWaterInspection,
  saveDrinkingWaterInspection,
  updateDrinkingWaterInspection
} from "../../api/User";

const translations = {
  en: {
    back: "Back",
    title: "Village Drinking Water Supply Status",
    langToggle: "हिन्दी",
    q1: "1. Source(s) of Drinking Water",
    canal: "Canal based Water Supply",
    waterWorks: "Water Works",
    tubeWell: "Tube Well",
    handPump: "Hand Pump",
    others: "Others",
    othersSpecify: "Please specify other sources",
    q2: "2. Is Drinking Water Supply Regular?",
    yes: "Yes",
    no: "No",
    q3: "3. Water Supply Frequency",
    daily: "Daily",
    altDay: "Alternate Day",
    weekly: "Weekly",
    irregular: "Irregular",
    q4: "4. Average Water Supply Duration Hours(per Day)",
    hoursPerDay: "Hours (per Day)",
    q5: "5. Drinking Water Quality",
    good: "Good",
    satisfactory: "Satisfactory",
    poor: "Poor",
    q6: "6. Is Any Water Shortage Area Identified?",
    shortageSpecify: "If yes, please mention the village/ward/locality",
    q7: "7. Is Any Pipeline Leakage Found?",
    leakageSpecify: "If yes, please mention the location",
    q8: "8. Is Any Immediate Repair/Maintenance Required?",
    repairSpecify: "If yes, please specify",
    q9: "9. Overall Status of Drinking Water Supply",
    needsImprovement: "Needs Improvement",
    cancel: "Cancel",
    save: "Save",
    update: "Update",
    saving: "Saving...",
    validationError: "Please resolve the validation errors in the form.",
    hoursError: "Please enter a valid number of hours (0-24 whole numbers only)",
    shortageError: "Location is required if water shortage is identified",
    leakageError: "Location is required if pipeline leakage is found",
    repairError: "Specify details is required if repair/maintenance is required",
    othersError: "Please specify the other source",
    confirmTitle: "Confirm Save",
    confirmMsgSave: "After saving you will allow only edit once. Do you want to proceed?",
    confirmMsgUpdate: "You will not be allowed to edit this form after saving. Do you want to proceed?",
    okay: "Okay",
  },
  hi: {
    back: "पीछे",
    title: "गाँव में पेयजल आपूर्ति की स्थिति",
    langToggle: "English",
    q1: "1. पेयजल का स्रोत",
    canal: "नहर आधारित जलापूर्ति",
    waterWorks: "वाटर वर्क्स",
    tubeWell: "ट्यूबवेल",
    handPump: "हैंडपंप",
    others: "अन्य",
    othersSpecify: "कृपया अन्य स्रोत स्पष्ट करें",
    q2: "2. क्या पेयजल आपूर्ति नियमित है?",
    yes: "हाँ",
    no: "नहीं",
    q3: "3. जलापूर्ति की आवृत्ति",
    daily: "दैनिक / रोजाना",
    altDay: "एक दिन छोड़कर",
    weekly: "साप्ताहिक",
    irregular: "अनियमित",
    q4: "4. औसत जलापूर्ति अवधि घंटे (प्रति दिन)",
    hoursPerDay: "घंटे प्रति दिन",
    q5: "5. पेयजल की गुणवत्ता",
    good: "अच्छी",
    satisfactory: "संतोषजनक",
    poor: "खराब",
    q6: "6. क्या पानी की कमी वाले क्षेत्र की पहचान की गई है?",
    shortageSpecify: "यदि हाँ, तो कृपया गाँव/वार्ड/इलाके का उल्लेख करें",
    q7: "7. क्या कोई पाइपलाइन लीकेज पाई गई है?",
    leakageSpecify: "यदि हाँ, तो कृपया स्थान का उल्लेख करें",
    q8: "8. क्या कोई तत्काल मरम्मत/रखरखाव आवश्यक है?",
    repairSpecify: "यदि हाँ, तो कृपया स्पष्ट करें",
    q9: "9. पेयजल आपूर्ति की समग्र स्थिति",
    needsImprovement: "सुधार की आवश्यकता है",
    cancel: "रद्द करें",
    save: "सहेजें",
    update: "अपडेट करें",
    saving: "सहेज रहा है...",
    validationError: "कृपया फॉर्म में त्रुटियों को ठीक करें।",
    hoursError: "कृपया घंटों की वैध संख्या दर्ज करें 0-24 (केवल पूर्णांक संख्या)",
    shortageError: "पानी की कमी होने पर स्थान दर्ज करना आवश्यक है",
    leakageError: "पाइपलाइन लीकेज होने पर स्थान दर्ज करना आवश्यक है",
    repairError: "मरम्मत की आवश्यकता होने पर विवरण देना आवश्यक है",
    othersError: "कृपया अन्य स्रोत का विवरण दें",
    confirmTitle: "बदलाव सहेजें",
    confirmMsgSave: "सहेजने के बाद आपको केवल एक बार एडिट करने की अनुमति होगी। क्या आप आगे बढ़ना चाहते हैं?",
    confirmMsgUpdate: "इस बार सहेजने के बाद आपको इस फॉर्म को दोबारा एडिट करने की अनुमति नहीं होगी। क्या आप आगे बढ़ना चाहते हैं?",
    okay: "ठीक है",
  }
};

const DrinkingWaterForm = () => {
  const { meetingId } = useParams();
  const [searchParams] = useSearchParams();
  const gpId = searchParams.get("gp");
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const userId = sessionStorage.getItem("user_id");

  const [lang, setLang] = useState("en"); // English default
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [recordId, setRecordId] = useState(null);
  const [isFrozen, setIsFrozen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  // Form Fields
  const [waterSources, setWaterSources] = useState({
    canal: false,
    waterWorks: false,
    tubeWell: false,
    handPump: false,
    others: false,
  });
  const [otherSourceDetails, setOtherSourceDetails] = useState("");
  const [regularSupply, setRegularSupply] = useState(true);
  const [waterSupplyFrequency, setWaterSupplyFrequency] = useState("Daily");
  const [averageSupplyHours, setAverageSupplyHours] = useState("");
  const [waterQuality, setWaterQuality] = useState("Good");
  const [waterShortage, setWaterShortage] = useState(false);
  const [waterShortageLocation, setWaterShortageLocation] = useState("");
  const [pipelineLeakage, setPipelineLeakage] = useState(false);
  const [pipelineLeakageLocation, setPipelineLeakageLocation] = useState("");
  const [repairRequired, setRepairRequired] = useState(false);
  const [repairDetails, setRepairDetails] = useState("");
  const [overallStatus, setOverallStatus] = useState("Satisfactory");

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    const loadRecord = async () => {
      try {
        setLoading(true);
        const res = await getDrinkingWaterInspection(token, meetingId);
        if (res.status === "success" && res.data) {
          const data = res.data;
          setRecordId(data.id);
          
          // Parse water sources JSON
          const sources = data.water_sources || [];
          setWaterSources({
            canal: sources.includes("Canal"),
            waterWorks: sources.includes("Water Works"),
            tubeWell: sources.includes("Tube Well"),
            handPump: sources.includes("Hand Pump"),
            others: sources.some(s => s.startsWith("Others:")),
          });
          const otherStr = sources.find(s => s.startsWith("Others:"));
          if (otherStr) {
            setOtherSourceDetails(otherStr.replace("Others: ", ""));
          }

          setRegularSupply(!!data.regular_supply);
          setWaterSupplyFrequency(data.water_supply_frequency || "Daily");
          setAverageSupplyHours(data.average_supply_hours || "");
          setWaterQuality(data.water_quality || "Good");
          setWaterShortage(!!data.water_shortage);
          setWaterShortageLocation(data.water_shortage_location || "");
          setPipelineLeakage(!!data.pipeline_leakage);
          setPipelineLeakageLocation(data.pipeline_leakage_location || "");
          setRepairRequired(!!data.repair_required);
          setRepairDetails(data.repair_details || "");
          setOverallStatus(data.overall_status || "Satisfactory");

          // Handle freeze logic
          if (data.updated_by !== null && data.updated_by !== 0) {
            setIsFrozen(true);
          }
        }
      } catch (error) {
        console.error("Error loading drinking water inspection details:", error);
        toast.error("Failed to load existing inspection details.", { autoClose: 2000 });
      } finally {
        setLoading(false);
      }
    };

    if (meetingId) {
      loadRecord();
    }
  }, [meetingId, token]);

  useEffect(() => {
    const role = sessionStorage.getItem("role_id");
    if (["1", "3", "7", "8"].includes(role)) {
      setIsFrozen(true);
    }
  }, []);

  const handleSourceChange = (event) => {
    if (isFrozen) return;
    setWaterSources({
      ...waterSources,
      [event.target.name]: event.target.checked,
    });
  };

  const isValidHours = (val) => {
    if (val === "" || isNaN(val)) return false;
    const num = Number(val);
    return Number.isInteger(num) && num >= 0 && num <= 24;
  };

  const isFormValid = () => {
    if (isFrozen) return false;

    // Q1: Must have at least one checkbox checked
    const hasSource = waterSources.canal || waterSources.waterWorks || waterSources.tubeWell || waterSources.handPump || waterSources.others;
    if (!hasSource) return false;
    
    // Q1 Other check
    if (waterSources.others && !otherSourceDetails.trim()) return false;
    
    // Q4 Check
    if (!isValidHours(averageSupplyHours)) return false;
    
    // Q6 Check
    if (waterShortage && !waterShortageLocation.trim()) return false;
    
    // Q7 Check
    if (pipelineLeakage && !pipelineLeakageLocation.trim()) return false;
    
    // Q8 Check
    if (repairRequired && !repairDetails.trim()) return false;

    return true;
  };

  const validate = () => {
    const errors = {};
    if (!isValidHours(averageSupplyHours)) {
      errors.averageSupplyHours = translations[lang].hoursError;
    }
    if (waterShortage && !waterShortageLocation.trim()) {
      errors.waterShortageLocation = translations[lang].shortageError;
    }
    if (pipelineLeakage && !pipelineLeakageLocation.trim()) {
      errors.pipelineLeakageLocation = translations[lang].leakageError;
    }
    if (repairRequired && !repairDetails.trim()) {
      errors.repairDetails = translations[lang].repairError;
    }
    if (waterSources.others && !otherSourceDetails.trim()) {
      errors.otherSourceDetails = translations[lang].othersError;
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSaveClick = (e) => {
    e.preventDefault();
    if (isFrozen) return;
    if (!validate()) {
      toast.error(translations[lang].validationError, { autoClose: 2000 });
      return;
    }
    setOpenConfirm(true);
  };

  const executeSave = async () => {
    setOpenConfirm(false);
    try {
      setSaving(true);
      // Compile water sources list
      const sourcesList = [];
      if (waterSources.canal) sourcesList.push("Canal");
      if (waterSources.waterWorks) sourcesList.push("Water Works");
      if (waterSources.tubeWell) sourcesList.push("Tube Well");
      if (waterSources.handPump) sourcesList.push("Hand Pump");
      if (waterSources.others && otherSourceDetails.trim()) {
        sourcesList.push(`Others: ${otherSourceDetails.trim()}`);
      }

      const payload = {
        meeting_id: parseInt(meetingId),
        gram_panchayat_id: parseInt(gpId || sessionStorage.getItem("gp_data") || 0),
        water_sources: sourcesList,
        regular_supply: regularSupply,
        water_supply_frequency: waterSupplyFrequency,
        average_supply_hours: parseFloat(averageSupplyHours),
        water_quality: waterQuality,
        water_shortage: waterShortage,
        water_shortage_location: waterShortage ? waterShortageLocation : "",
        pipeline_leakage: pipelineLeakage,
        pipeline_leakage_location: pipelineLeakage ? pipelineLeakageLocation : "",
        repair_required: repairRequired,
        repair_details: repairRequired ? repairDetails : "",
        overall_status: overallStatus,
        remarks: "", // Remarks field removed
      };

      let res;
      if (recordId) {
        payload.updated_by = parseInt(userId);
        res = await updateDrinkingWaterInspection(token, recordId, payload);
      } else {
        payload.created_by = parseInt(userId);
        res = await saveDrinkingWaterInspection(token, payload);
      }

      if (res.status === "success") {
        toast.success(res.message || "Saved successfully!", { autoClose: 1500 });
        setTimeout(() => {
          navigate("/gram-sabha-inspection");
        }, 1500);
      } else {
        toast.error(res.message || "Failed to save form record.");
      }
    } catch (error) {
      console.error("Error saving form:", error);
      toast.error("An error occurred while saving the form.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <img src={loader} alt="loading..." />
      </div>
    );
  }

  return (
    <div style={{ padding: "20px", width: "100%" }}>
      <ToastContainer />

      {/* Confirmation Modal */}
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title" style={{ fontWeight: "bold" }}>
          {translations[lang].confirmTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description" style={{ color: "#333" }}>
            {recordId ? translations[lang].confirmMsgUpdate : translations[lang].confirmMsgSave}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: "15px 24px" }}>
          <Button 
            onClick={() => setOpenConfirm(false)} 
            variant="outlined" 
            style={{ textTransform: "none", color: "#666", borderColor: "#ccc" }}
          >
            {translations[lang].cancel}
          </Button>
          <Button 
            onClick={executeSave} 
            variant="contained" 
            autoFocus
            style={{ textTransform: "none", backgroundColor: "#4763E4", color: "#fff" }}
          >
            {translations[lang].okay}
          </Button>
        </DialogActions>
      </Dialog>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <Button 
            onClick={() => navigate("/gram-sabha-inspection")} 
            variant="outlined" 
            startIcon={<ArrowBackIcon />}
            style={{ textTransform: "none", color: "#4763E4", borderColor: "#4763E4" }}
          >
            {translations[lang].back}
          </Button>
          <h3 style={{ margin: 0, fontWeight: "bold" }}>
            {translations[lang].title}
          </h3>
        </div>
        <Button 
          onClick={() => setLang(lang === "en" ? "hi" : "en")} 
          variant="outlined" 
          style={{ textTransform: "none", color: "#4763E4", borderColor: "#4763E4", fontWeight: "bold" }}
        >
          {translations[lang].langToggle}
        </Button>
      </div>
      <hr style={{ border: "1px solid #ddd", marginBottom: "30px" }} />

      
      {!isFrozen && recordId && (
        <div style={{
          backgroundColor: "#FEF3C7",
          color: "#92400E",
          border: "1px solid #FCD34D",
          padding: "15px",
          borderRadius: "6px",
          marginBottom: "25px",
          fontWeight: "bold",
          fontSize: "14px"
        }}>
          ⚠️ {lang === "en" ? "Note: You can edit this form only one time." : "ध्यान दें: आप इस फॉर्म को केवल एक ही बार एडिट कर सकते हैं।"}
        </div>
      )}

      <form onSubmit={handleSaveClick} style={{ background: "#fff", padding: "30px", borderRadius: "8px", boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)", width: "100%" }}>
        
        {/* 1. Source of Drinking Water */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>{translations[lang].q1}</h5>
          <FormGroup row>
            <FormControlLabel
              control={<Checkbox checked={waterSources.canal} onChange={handleSourceChange} name="canal" color="primary" disabled={isFrozen} />}
              label={translations[lang].canal}
            />
            <FormControlLabel
              control={<Checkbox checked={waterSources.waterWorks} onChange={handleSourceChange} name="waterWorks" color="primary" disabled={isFrozen} />}
              label={translations[lang].waterWorks}
            />
            <FormControlLabel
              control={<Checkbox checked={waterSources.tubeWell} onChange={handleSourceChange} name="tubeWell" color="primary" disabled={isFrozen} />}
              label={translations[lang].tubeWell}
            />
            <FormControlLabel
              control={<Checkbox checked={waterSources.handPump} onChange={handleSourceChange} name="handPump" color="primary" disabled={isFrozen} />}
              label={translations[lang].handPump}
            />
            <FormControlLabel
              control={<Checkbox checked={waterSources.others} onChange={handleSourceChange} name="others" color="primary" disabled={isFrozen} />}
              label={translations[lang].others}
            />
          </FormGroup>
          {waterSources.others && (
            <TextField
              label={translations[lang].othersSpecify}
              fullWidth
              size="small"
              variant="outlined"
              style={{ marginTop: "10px" }}
              value={otherSourceDetails}
              onChange={(e) => setOtherSourceDetails(e.target.value)}
              disabled={isFrozen}
              error={!!formErrors.otherSourceDetails}
              helperText={formErrors.otherSourceDetails}
            />
          )}
        </div>

        {/* 2. Is Drinking Water Supply Regular? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q2}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={regularSupply ? "Yes" : "No"} onChange={(e) => setRegularSupply(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 3. Water Supply Frequency */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q3}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={waterSupplyFrequency} onChange={(e) => setWaterSupplyFrequency(e.target.value)}>
              <FormControlLabel value="Daily" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].daily} />
              <FormControlLabel value="Alternate Day" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].altDay} />
              <FormControlLabel value="Weekly" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].weekly} />
              <FormControlLabel value="Irregular" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].irregular} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 4. Average Water Supply Duration */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>{translations[lang].q4}</h5>
          <TextField
            label={translations[lang].hoursPerDay}
            type="number"
            size="small"
            style={{ width: "200px" }}
            value={averageSupplyHours}
            onChange={(e) => {
              const val = e.target.value;
              if (val === "") {
                setAverageSupplyHours("");
                return;
              }
              const num = Number(val);
              if (num >= 0 && num <= 24) {
                setAverageSupplyHours(val);
              }
            }}
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            disabled={isFrozen}
            error={!!formErrors.averageSupplyHours}
            helperText={formErrors.averageSupplyHours}
            inputProps={{ step: "1", min: "0", max: "24" }}
          />
        </div>

        {/* 5. Drinking Water Quality */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q5}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={waterQuality} onChange={(e) => setWaterQuality(e.target.value)}>
              <FormControlLabel value="Good" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].good} />
              <FormControlLabel value="Satisfactory" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].satisfactory} />
              <FormControlLabel value="Poor" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].poor} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 6. Is Any Water Shortage Area Identified? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q6}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={waterShortage ? "Yes" : "No"} onChange={(e) => setWaterShortage(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
          {waterShortage && (
            <TextField
              label={translations[lang].shortageSpecify}
              fullWidth
              size="small"
              variant="outlined"
              style={{ marginTop: "10px" }}
              value={waterShortageLocation}
              onChange={(e) => setWaterShortageLocation(e.target.value)}
              disabled={isFrozen}
              error={!!formErrors.waterShortageLocation}
              helperText={formErrors.waterShortageLocation}
            />
          )}
        </div>

        {/* 7. Is Any Pipeline Leakage Found? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q7}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={pipelineLeakage ? "Yes" : "No"} onChange={(e) => setPipelineLeakage(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
          {pipelineLeakage && (
            <TextField
              label={translations[lang].leakageSpecify}
              fullWidth
              size="small"
              variant="outlined"
              style={{ marginTop: "10px" }}
              value={pipelineLeakageLocation}
              onChange={(e) => setPipelineLeakageLocation(e.target.value)}
              disabled={isFrozen}
              error={!!formErrors.pipelineLeakageLocation}
              helperText={formErrors.pipelineLeakageLocation}
            />
          )}
        </div>

        {/* 8. Is Any Immediate Repair/Maintenance Required? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q8}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={repairRequired ? "Yes" : "No"} onChange={(e) => setRepairRequired(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
          {repairRequired && (
            <TextField
              label={translations[lang].repairSpecify}
              fullWidth
              size="small"
              variant="outlined"
              style={{ marginTop: "10px" }}
              value={repairDetails}
              onChange={(e) => setRepairDetails(e.target.value)}
              disabled={isFrozen}
              error={!!formErrors.repairDetails}
              helperText={formErrors.repairDetails}
            />
          )}
        </div>

        {/* 9. Overall Status of Drinking Water Supply */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q9}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={overallStatus} onChange={(e) => setOverallStatus(e.target.value)}>
              <FormControlLabel value="Good" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].good} />
              <FormControlLabel value="Satisfactory" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].satisfactory} />
              <FormControlLabel value="Needs Improvement" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].needsImprovement} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* Submit */}
        <div style={{ display: "flex", gap: "15px", justifyContent: "flex-end", alignItems: "center" }}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => navigate("/gram-sabha-inspection")}
            disabled={saving}
            style={{ textTransform: "none", color: "#666", borderColor: "#ccc" }}
          >
            {translations[lang].cancel}
          </Button>
          {!isFrozen && (
            <Button
              type="submit"
              variant="contained"
              disabled={saving || !isFormValid()}
              style={{ textTransform: "none", backgroundColor: isFormValid() ? "#4763E4" : "#ccc" }}
            >
              {saving ? translations[lang].saving : recordId ? translations[lang].update : translations[lang].save}
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};

export default DrinkingWaterForm;
